import { ObjectDetailDrill } from "../drill/ObjectDetailDrill";

const ObjectMode = {
  name: "object",
  drills: [ObjectDetailDrill],
};

export default ObjectMode;
